// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"226":"password-reset","535":"login","567":"leaderboard","672":"mailwait","892":"PageNotFound"}[chunkId] + "." + {"226":"613e05cf","535":"c689e8dc","567":"7764b461","672":"b8a76fee","892":"ceab6114"}[chunkId] + ".css";
};